import { atom } from 'jotai';

import { AnyStepModel, StepModel } from './use-steps';

export const createStepsAtom = <T extends AnyStepModel>(initialValue: StepModel<T>) => {
  const stepsAtom = atom<StepModel<T>[]>([initialValue]);
  const pushAtom = atom(null, (get, set, value: StepModel<T>) => set(stepsAtom, [...get(stepsAtom), value]));
  const backAtom = atom(null, (get, set) => {
    const prev = get(stepsAtom);
    set(stepsAtom, prev.length == 1 ? prev : prev.slice(0, -1));
  });
  const resetStepAtom = atom(null, (_, set) => set(stepsAtom, [initialValue]));
  const currentStepAtom = atom((get) => get(stepsAtom).at(-1)!);
  return {
    pushAtom,
    backAtom,
    resetStepAtom,
    currentStepAtom,
  };
};
